module.exports = __webpack_public_path__ + "img/loaderA.31125553.png";